var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data",style:(_vm.elStyle)},[_c('p',[_vm._v(_vm._s(_vm.$t('analytics.noData')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }